<header class="header fixed-top clearfix" *ngIf="IsACPUserLoggedIn && hasAcpAuthToken">
  <div class="brand"> 
    <a *ngIf="(settingsAppl['appStorageService'] == 'NAS')?true:false" routerLink="/acp/{{ACPProjectIdentifier}}/reports" class="logo"> 
		<img [src]="logoUrl" *ngIf="logoUrl!=''" />
	</a>
	<a *ngIf="(settingsAppl['appStorageService'] == 'S3')?true:false" routerLink="/acp/{{ACPProjectIdentifier}}/reports" class="logo"> 
		<img [src]="logoPath" *ngIf="logoPath!=''" />
		<!-- <img src="assets/img/logo.png" alt="logo" *ngIf="logoUrl==''"> -->
	</a>
    <button  data-toggle="collapse-side" data-target=".side-collapse" data-target-2=".side-collapse-container" type="button" class="sidebar-toggler">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </button> 
  </div>  
  <div class="userdropdown row align-items-center"> 
    <div class="dropdown show col">
	  <span *ngIf = "ulrAcp==1">{{ACPprojectName}}</span>
	  <!-- <a class="btn dropdown-toggle pull-right" href="#" role="button" id="profile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> -->
      <a class="btn pull-right" href="#" role="button" id="profile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="avatar" *ngIf="logoUrl==''">
			<img src="assets/img/avatar5.png" alt="userimage">
		</span>
        <span class="username d-none d-md-inline-block">Welcome <span>{{ACPLoggedUserName}}</span></span>
      </a>  
      <!-- <div class="dropdown-menu dropdown-menu-right" aria-labelledby="profile">
        <span class="dropdown-item"><i class="fa fa-envelope"></i> rajamanickam.raju@sifycorp.com</span>
        <a class="dropdown-item" [routerLink]="['/user/achieve']"><i class="fa fa-user"></i> Profile</a>
        <a class="dropdown-item" [routerLink]="['/user/userSetting']"><i class="fa fa-cog"></i> Settings</a>
        <a class="dropdown-item" (click)="onUserSignOut()"><i class="fa fa-sign-out"></i> Sign out</a>
      </div> -->
    </div>  
    <a class="btn logout-btn col-auto" (click)="acpUserLogout()"> <i class="fa d-inline fa-lg fa-power-off" title="Logout"></i></a>          
  </div> 
</header>